

















import { Component, Prop, Mixins } from "vue-property-decorator";

// Types
import { IClient } from "@/models/clients";
import { IComponentTag } from "@/models/ui";
import Context from "@/mixins/context";

@Component({
  components: {
    "child-accounts-provider": () =>
      import("@/components/app/global/client/childAccountsProvider.vue"),
    "child-accounts-listing": () =>
      import("@/components/app/global/client/childAccountsListing.vue")
  }
})
export default class ChildAccountsListingComponent extends Mixins(Context) {
  // Props

  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise", "div"].includes(tag)
  })
  public readonly tag!: IComponentTag;

  @Prop({ required: false })
  public client!: IClient;
}
